import { render } from "./App.vue?vue&type=template&id=3b1839f9"
const script = {}
script.render = render

export default script